module.exports = __webpack_public_path__ + "img/SM.7199b709.svg";